import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser } from '../../actions/authActions';
import { PRIME_DAY_PATH, isPromoted } from '../../utils/primeDay';

const Navbar = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(state => state.auth);
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = useCallback((e) => {
    e.preventDefault();
    dispatch(logoutUser());
  }, [dispatch]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const primeItem = isPromoted() && (
    <li className="nav-item">
      <Link className="nav-link" to={PRIME_DAY_PATH} onClick={() => setIsOpen(false)}>Prime Day</Link>
    </li>
  );

  const authLinks = (
    <ul className="navbar-nav ml-auto">
      {primeItem}
      <li className="nav-item">
        <Link className="nav-link" to="/blog" onClick={() => setIsOpen(false)}>Blog</Link>
      </li>
      <li className="nav-item">
        <button
          onClick={handleLogout}
          className="nav-link btn btn-link text-light"
          style={{ border: 'none', background: 'none' }}
          aria-label="Logout"
        >
          Logout
        </button>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/generate" onClick={() => setIsOpen(false)}>Post</Link>
      </li>
    </ul>
  );

  const guestLinks = (
    <ul className="navbar-nav ml-auto">
      {primeItem}
      <li className="nav-item">
        <Link className="nav-link" to="/blog" onClick={() => setIsOpen(false)}>Blog</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/sellers" onClick={() => setIsOpen(false)}>For sellers</Link>
      </li>
    </ul>
  );

  return (
    <nav className="navbar navbar-expand-sm navbar-dark bg-dark mb-4">
      <div className="container">
        <Link className="navbar-brand" to="/">Lite Pocket Deals</Link>

        {/* One always-visible link on mobile: Prime Day while it is promoted, otherwise Blog.
            lib/prerender.js renders the same navbar on the server. */}
        {isPromoted() ? (
          <Link className="nav-link text-light d-sm-none" to={PRIME_DAY_PATH} style={{ marginRight: '10px' }}>Prime Day</Link>
        ) : (
          <Link className="nav-link text-light d-sm-none" to="/blog" style={{ marginRight: '10px' }}>Blog</Link>
        )}

        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="mobile-nav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="mobile-nav">
          {isAuthenticated ? authLinks : guestLinks}
        </div>
      </div>
    </nav>
  );
};

Navbar.propTypes = {
  // No props needed since we're using hooks
};

export default Navbar;
